import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Link} from 'shells/link/link';

export function TerritoriesBanner() {
    return (
        <div className='mb-16 full-width'>
            <FlashBanner type='warning' leftAlignContent={true} animate={false} hasBorder={true}>
                <div className='full-width justify-sb flex align-center'>
                    You cannot add any more territories on your current plan.
                    <Link variant='primary' href='/setup/billing/sales' newTab={true}>
                        Upgrade your plan
                    </Link>
                </div>
            </FlashBanner>
        </div>
    );
}
